import styled, { css } from 'styled-components';
import { SearchFieldSize, SearchFieldState, SearchFieldVariant } from '.';

type ContainerProps = {
  $size: SearchFieldSize;
  $variant: SearchFieldVariant;
  $state: SearchFieldState;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  pointer-events: auto;

  background-color: ${({ theme }) => theme.tokens.colors.surface};

  ${({ theme, $size }) => {
    if ($size === 1) {
      return css`
        padding: ${theme.spacing[$size + 1]}px;
      `;
    }
    return css`
      padding-top: ${theme.spacing[$size + 1]}px;
      padding-right: ${theme.spacing[$size]}px;
      padding-bottom: ${theme.spacing[$size + 1]}px;
      padding-left: ${theme.spacing[$size]}px;
    `;
  }}

  border: 2px solid ${({ theme }) => theme.colors.neutral.neutral_alpha[5]};
  gap: ${({ theme, $size }) => theme.spacing[$size]}px;

  &:hover {
    ${({ theme, $state }) => {
      if (['disable', 'readonly'].includes($state))
        return css`
          border-color: ${theme.colors.neutral.neutral_alpha[5]};
        `;

      return css`
        border-color: ${theme.colors.accent.accent_alpha[11]};
      `;
    }}
  }

  ${({ theme, $state }) => {
    if ($state !== 'filled') return '';
    return css`
      border-width: 1px;
      border-color: ${theme.colors.accent.accent_alpha[7]};
    `;
  }}

  border-radius: ${({ theme }) => theme.radius[3]}px;
`;

export const Input = styled.input`
  display: flex;
  flex: 1;

  border: none;
  background: none;
  outline: none;
  box-shadow: none;

  padding-right: ${({ theme }) => theme.spacing[1]}px;
  padding-left: ${({ theme }) => theme.spacing[1]}px;

  ${({ theme }) => {
    return css`
      font-size: ${theme.typography.font.size[3]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.regular};
      line-height: ${theme.typography.font.line_height[3]}px;
      text-align: left;
      color: ${theme.colors.neutral.neutral_alpha[12]};

      &::placeholder {
        font-size: ${theme.typography.font.size[3]}px;
        font-family: var(--font-${theme.typography.font.family.text});
        font-weight: ${theme.typography.font.weight.medium};
        line-height: ${theme.typography.font.line_height[3]}px;
        text-align: left;
        color: ${theme.colors.neutral.neutral_alpha[9]};
      }
    `;
  }};
`;
